import React, { useState } from "react";
import { Script } from "gatsby";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDice, faBell } from "@fortawesome/free-solid-svg-icons";

const NewsletterForm = () => {
    const [loaded, setLoaded] = useState(false)

    return (
        <>
            <form
                action="https://vegas-aces.us17.list-manage.com/subscribe/post?u=20d7f04d7a4aad746c5ec7cb4&amp;id=5fda993e17"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate"
                target="_blank"
                noValidate="novalidate">
                <div id="mc_embed_signup_scroll" className="grouped">
                    <input type="email" defaultValue="" name="EMAIL" className="required email py-2 px-2 rounded mr-4 lg:w-80 mb-3 lg:mb-0" placeholder="name@email.com" id="mce-EMAIL" />
                    <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
                        <input type="text" name="b_20d7f04d7a4aad746c5ec7cb4_5fda993e17" tabIndex="-1" defaultValue="" /></div>
                    <button type="submit" name="subscribe" id="mc-embedded-subscribe" className="text-white bg-red-900 hover:bg-red-950 transition-colors duration-100 rounded py-2 px-6 font-semi-condensed font-bold uppercase">Subscribe <FontAwesomeIcon icon={faBell} className="ml-2" /></button>
                </div>
                <div id="mce-responses" className="clear is-full-width text-success">
                    <div className="response" id="mce-error-response" style={{ display: "none" }}></div>
                    <div className="response" id="mce-success-response" style={{ display: "none" }}></div>
                </div>
            </form>
            <Script src='https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js' onLoad={() => {
                window.addEventListener("load", () => {
                    // const $ = window.jQuery.noConflict(true);
                    setLoaded(true)
                });
            }
            } />
            {loaded &&
                <Script>
                    {`(function ($) {
                        window.fnames = new Array();
                        window.ftypes = new Array();
                        fnames[0] = 'EMAIL';
                        ftypes[0] = 'email';
                        }(jQuery));
                        var $mcj = jQuery.noConflict(true);`}
                </Script>
            }
        </>
    )
}

export const Newsletter = () => {
    return (
        <div className="py-5 px-3 bg-felt-200 text-center">
            <div className="container mx-auto px-3 2xl:px-0">
                <h2 className="uppercase font-black font-expanded text-xl mb-2">
                    <FontAwesomeIcon icon={faDice} className="mr-3" />
                    Get gamewise, now.</h2>
                <p className="mb-3">Don’t miss interviews, upcoming games, dealer and player tips, and more.</p>
                <NewsletterForm />
            </div>
        </div>
    )
}